import React from 'react';
import { Link } from 'react-router-dom';
import StartButton from '@/components/site/StartButton';
import SectionHeader from '@/components/site/SectionHeader';
import GoldText from '@/components/site/GoldText';

const areas = [
  ['Improve what is running', 'Review output quality, exceptions, user feedback, and potential refinements.'],
  ['Prioritize what comes next', 'Assess new use cases, dependencies, implementation effort, and expected value.'],
  ['Help the team use it well', 'Clarify responsibilities, improve operating processes, and support adoption.'],
];

const ConsultingPreview = () => (
  <section aria-labelledby="consulting-title" className="border-t border-rule">
    <div className="section-container">
      <SectionHeader
        id="consulting-title"
        eyebrow="08 / After the pilot"
        title={
          <>
            After the pilot, <GoldText>make the next move deliberately.</GoldText>
          </>
        }
      >
        <p>
          GoldCrusade can stay involved to review performance, support adoption, and help decide where AI should—and
          should not—play a larger role.
        </p>
      </SectionHeader>

      <ul className="reveal mt-14 grid border border-rule md:grid-cols-3">
        {areas.map(([title, body], i) => (
          <li
            key={title}
            className="border-b border-rule p-7 last:border-b-0 sm:p-8 md:border-b-0 md:border-r md:last:border-r-0"
          >
            <p className="meta-label mb-5">0{i + 1}</p>
            <h3 className="mb-3 text-[1.75rem] leading-tight">{title}</h3>
            <p className="text-mist">{body}</p>
          </li>
        ))}
      </ul>

      <div className="reveal mt-10 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <div className="max-w-2xl">
          <p className="mb-2 font-serif text-2xl">
            <GoldText>Ongoing consulting, scoped to your business.</GoldText>
          </p>
          <p className="text-sm text-mist">
            Consulting cadence, deliverables, and fees are agreed separately. Additional implementation and managed
            technical operations are included only when specified.
          </p>
        </div>
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
          <Link to="/consulting" className="text-link">
            Explore ongoing consulting →
          </Link>
          <StartButton interest="consulting" />
        </div>
      </div>
    </div>
  </section>
);

export default ConsultingPreview;
